import {Box, Grid, makeStyles} from "@material-ui/core";
import React, {FunctionComponent, useEffect, useState} from "react";

import {ReactComponent as StarSVG} from "../../Images/star.svg";
import {ReactComponent as FilledStarSVG} from "../../Images/starFilled.svg";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";

const Rating: FunctionComponent<{ initialValue: number, onChange?: (rating: number) => void }> = (
    {
        onChange,
        initialValue
    }) => {
    const [rating, setRating] = useState(initialValue);
    const brandColor = useSelector((state: RootState) => state?.branding.brandHeader);
    const useStyle = makeStyles((theme) => ({
        starContainer: {
            cursor: "pointer"
        }
    }));

    useEffect(() => {
        if (onChange) {
            onChange(rating);
        }
    }, [rating]);

    const handleClick = (value) => {
        if (onChange) {
            setRating(value);
            return;
        }
        return;
    };

    const classes = useStyle();

    return (
        <Grid container>
            <Box
                className={classes.starContainer}
                onClick={() => {
                    handleClick(1);
                }}
            >
                {
                    rating > 0 ? <FilledStarSVG fill={brandColor}/> : <StarSVG stroke={brandColor}/>
                }
            </Box>
            <Box
                className={classes.starContainer}
                onClick={() => {
                    handleClick(2);
                }}
            >
                {
                    rating > 1 ? <FilledStarSVG fill={brandColor}/> : <StarSVG stroke={brandColor}/>
                }
            </Box>
            <Box
                className={classes.starContainer}
                onClick={() => {
                    handleClick(3);
                }}
            >
                {
                    rating > 2 ? <FilledStarSVG fill={brandColor}/> : <StarSVG stroke={brandColor}/>
                }
            </Box>
            <Box
                className={classes.starContainer}
                onClick={() => {
                    handleClick(4);
                }}
            >
                {
                    rating > 3 ? <FilledStarSVG fill={brandColor}/> : <StarSVG stroke={brandColor}/>
                }
            </Box>
            <Box
                className={classes.starContainer}
                onClick={() => {
                    handleClick(5);
                }}
            >
                {
                    rating > 4 ? <FilledStarSVG fill={brandColor}/> : <StarSVG stroke={brandColor}/>
                }
            </Box>
        </Grid>
    );
};

export default Rating;
